import auth from '../auth'

// Used as interceptor in order to fetch the value via function
const provideJWT = config => {
	config.headers.common['Authorization'] = `Bearer ${auth.getAccessToken()}`
	return config
}

export { provideJWT }



// WEBPACK FOOTER //
// ./src/common/api/token.js